// extracted by mini-css-extract-plugin
export default {"cls1":"k9pY0OVDfTVEbcBZCCfW","cls2":"iBBi_UTjCjErjRtcBR8P k9pY0OVDfTVEbcBZCCfW"};